module.exports = __webpack_public_path__ + "img/m2.89289c4c.png";